var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mt-3",attrs:{"id":"table_5"}},[_vm._v(" Laadpunten per PID ")]),_c('TableManager',{ref:"TableManager",staticClass:"RVBChargingpointCount",attrs:{"loading":_vm.loading,"source-records":_vm.records,"category":"rvb-customer-reporting","uuid":"191a5278-afe8-4d92-90b4-0dc4554fb5f9"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }